import { Autocomplete, TextField } from '@mui/material';
import CountryList from 'src/data/CountryList';

// Aynı alan kodunu birden fazla ülke kullanabiliyor (+1 -> US, CA, DO, PR),
// bu yüzden liste ülke değil kod bazlı: her kod bir kez, sayısal sırayla.
const DIAL_CODES = [...new Set(CountryList.map((country) => country.dialCode).filter(Boolean))].sort(
  (a, b) => Number(a.slice(1)) - Number(b.slice(1))
);

// "90" ya da "+90" yazınca da bulunsun; baştan eşleşenler önce gelsin.
const filterDialCodes = (options, { inputValue }) => {
  const query = String(inputValue || '').replace(/[^\d]/g, '');
  if (!query) return options;

  const startsWith = [];
  const contains = [];
  options.forEach((option) => {
    const digits = option.slice(1);
    if (digits.startsWith(query)) {
      startsWith.push(option);
    } else if (digits.includes(query)) {
      contains.push(option);
    }
  });
  return [...startsWith, ...contains];
};

/**
 * Telefon ülke kodu seçimi. Dışarıya "+90" biçiminde metin verir.
 * Yazarak aranabilir; listede yalnızca kodlar görünür.
 */
export default function DialCodeSelect({
  label = 'Kod',
  value,
  onChange,
  error,
  helperText,
  ...other
}) {
  // Listede olmayan bir değer gelirse (eski kayıt) alan boş görünmesin.
  const options = value && !DIAL_CODES.includes(value) ? [value, ...DIAL_CODES] : DIAL_CODES;

  return (
    <Autocomplete
      fullWidth
      options={options}
      value={value || null}
      onChange={(_event, option) => onChange(option || '')}
      filterOptions={filterDialCodes}
      isOptionEqualToValue={(option, selected) => option === selected}
      noOptionsText="Sonuç bulunamadı"
      ListboxProps={{ style: { maxHeight: 280 } }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="+90"
          error={error}
          helperText={helperText}
          InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
        />
      )}
      {...other}
    />
  );
}
